import { render } from "./SwdWrapper.vue?vue&type=template&id=3b861e40"
import script from "./SwdWrapper.vue?vue&type=script&lang=js"
export * from "./SwdWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__